import defaultConfig, { RIGHT, LEFT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_046.jpg';
page.images = [
  {
    imageId: 'page046_zoom0',
    rectangle: {
      x: 1212,
      y: 1269,
      width: 564,
      height: 662,
    },
    imageSrc: 'images/page046/046 5.jpg',
  },
  {
    imageId: 'page046_zoom1',
    rectangle: {
      x: 612,
      y: 1263,
      width: 566,
      height: 666,
    },
    imageSrc: 'images/page046/046 4.jpg',
  },
  {
    imageId: 'page046_zoom2',
    rectangle: {
      x: 140,
      y: 1267,
      width: 434,
      height: 664,
    },
    imageSrc: 'images/page046/046 3.jpg',
  },
  {
    imageId: 'page046_zoom3',
    rectangle: {
      x: 982,
      y: 350,
      width: 790,
      height: 662,
    },
    imageSrc: 'images/page046/046 2.jpg',
  },
  {
    imageId: 'page046_zoom4',
    rectangle: {
      x: 140,
      y: 350,
      width: 802,
      height: 662,
    },
    imageSrc: 'images/page046/046 1.jpg',
  },
];
page.word = [
  {
    id: 'page023_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Napisz wyrazy tematycznie związane z obrazkiem. Kliknij w ikonę programu Word.',
      audio: 'files/page023/z23c2.mp3',
      item: {
        path: 'informatyka/files/page023/23_ćw_2_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page023_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
      audio: 'files/page023/z23c3.mp3',
      item: {
        path: 'informatyka/files/page023/23_ćw_3_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  {
    id: 'page023_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page019_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 400,
  //   },
  // },
  // {
  //   id: 'page019_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 800,
  //   },
  // },
];
export default page;
